export default "__VITE_ASSET__D7B3ONk___"